/*
 * er-smooth-scroll.js — gentle wheel-scroll smoothing for the homepage.
 *
 * Adds a soft "glide" to mouse-wheel scrolling so the long homepage feels more
 * fluid. Deliberately conservative:
 *   - Desktop + fine-pointer + motion-safe ONLY (never touch / coarse / reduced-motion).
 *   - Releases to the native scroll at the top/bottom edges (keeps rubber-band).
 *   - Steps aside while a drawer/modal is open (Dawn sets body.overflow-hidden).
 *   - Resyncs to any scroll it did not initiate (keyboard, scrollbar, anchor JS).
 * To disable: remove the <script> tag in layout/theme.liquid (index-only).
 */
(function () {
  'use strict';
  if (window.__erSmoothScroll) return;
  window.__erSmoothScroll = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;   // touch / most tablets
  if (window.innerWidth < 990) return;                          // desktop only

  var target = window.scrollY;
  var current = target;
  var running = false;

  function maxY() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
  function clamp(v) { var m = maxY(); return v < 0 ? 0 : (v > m ? m : v); }

  function loop() {
    var diff = target - current;
    if (Math.abs(diff) < 0.4) {
      current = target;
      window.scrollTo(0, current);
      running = false;
      return;
    }
    current += diff * 0.14;               // catch-up per frame — snappy, not floaty
    window.scrollTo(0, current);
    requestAnimationFrame(loop);
  }

  function onWheel(e) {
    // hand back to the browser: zoom, horizontal, modified, or already-handled scrolls
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.defaultPrevented) return;
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    if (document.body.classList.contains('overflow-hidden')) return;   // a drawer/modal is open

    var dy = e.deltaY;
    if (e.deltaMode === 1) dy *= 16;                       // lines -> px
    else if (e.deltaMode === 2) dy *= window.innerHeight;  // pages -> px

    if (!running) { target = current = window.scrollY; }   // resync before we take over
    var next = clamp(target + dy);
    if (next === target) return;                           // at an edge -> let native overscroll happen
    e.preventDefault();
    target = next;
    if (!running) { running = true; requestAnimationFrame(loop); }
  }

  // Any scroll we did NOT initiate (keyboard, scrollbar drag, anchor smooth-scroll) resyncs us.
  function onScroll() { if (!running) { current = target = window.scrollY; } }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (!running) { current = target = window.scrollY; }
    target = clamp(target);
  }, { passive: true });
})();
